// third-party
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
    currentTask: {},
    leaveEntry: [],
    timeEntry: [],
    projects: [],
    weekEntry: [],
    timesheetReview: []
};

const slice = createSlice({
    name: 'timesheet',
    initialState,
    reducers: {
        getTimesheet(state, action) {
            state.timeEntry = action.payload;
        },
        addTimeEntry(state, action) {
            state.timeEntry.push(action.payload);
        },
        editTimeEntry(state, action) {
            state.timeEntry = state.timeEntry.map((item) => (item.uuid === action.payload.uuid ? action.payload : item));
        },
        deleteTimeEntry(state, action) {
            state.timeEntry = state.timeEntry.filter((item) => item.uuid !== action.payload.uuid);
        },
        getCurrentTask(state, action) {
            state.currentTask = action.payload;
        },
        getLeaveEntry(state, action) {
            state.leaveEntry = action.payload;
        },
        getProjects(state, action) {
            state.projects = action.payload;
        },
        getWeekEntry(state, action) {
            state.weekEntry = action.payload;
        },
        addToWeekEntry(state, action) {
            state.weekEntry.push(action.payload);
        },
        editWeekEntry(state, action) {
            state.weekEntry = state.weekEntry.map((item) => (item.uuid === action.payload.uuid ? action.payload : item));
        },
        getTimesheetReview(state, action) {
            state.timesheetReview.push(action.payload);
        },
        clearTimesheetReview(state) {
            state.timesheetReview = [];
        }
    }
});

// Reducer actions
export const {
    addTimeEntry,
    deleteTimeEntry,
    editWeekEntry,
    editTimeEntry,
    addToWeekEntry,
    getCurrentTask,
    getLeaveEntry,
    getTimesheet,
    getProjects,
    getWeekEntry,
    getTimesheetReview,
    clearTimesheetReview
} = slice.actions;

// Reducer
export default slice.reducer;
